export default __webpack_public_path__ + "static/media/closureConfirmation.d16d88d4.svg";